import React from 'react';
import { RenderEditable, RenderElement } from 'components/RenderHelpers';
import { FormViewContent } from 'components/FormViewContent';

import Divider from 'ctsutheme/components/atoms/Divider';

const OpenItrfProviderForm = ({ data }) => {

    return <div>
        <RenderEditable
            state={false}
            editable={false}
            title="OPEN IRTF Provider Setup"
        >
            <RenderElement access>
                <>
                    <FormViewContent
                        primaryText="Minimum Non-required Credentials"
                        secondaryText={data?.minNonReqCred}
                    />
                    <Divider />
                    <FormViewContent
                        primaryText="Maximum Non-required Credentials"
                        secondaryText={data?.maxNonReqCred || '0'}
                    />
                    <Divider />
                    <FormViewContent
                        primaryText="From Credentials"
                        secondaryText={data.fromCred?.join ? data.fromCred?.join(', ') : ''}
                    />
                </>
            </RenderElement>
        </RenderEditable>
    </div>
};

export default OpenItrfProviderForm;